import { useContext } from "react"

import {
  CurrentContext,
  type CurrentContextValue,
} from "@/components/current-context-provider"

/**
 * Typed hook returning the current tenancy context.
 *
 * Throws when used outside a `<CurrentContextProvider>` — that's a programming
 * error and we want to surface it loudly rather than silently returning nulls.
 */
export function useCurrentContext(): CurrentContextValue {
  const ctx = useContext(CurrentContext)
  if (!ctx) {
    throw new Error(
      "useCurrentContext must be used within a <CurrentContextProvider>",
    )
  }
  return ctx
}
